<template>
  <div class="agreement">
    <div class="header">
      <div class="back" @click="goBack">
        <span class="iconfont icon-fanhui2"></span>
      </div>
      <div class="title">用户协议</div>
      <div class="back"></div>
    </div>
    <div class="content" v-html="agreementContent"></div>
  </div>
</template>
<script>
import { getUserAgreement } from "@api/user";
export default {
  name: "UserAgreement",
  data() {
    return {
      agreementContent: ""
    };
  },
  mounted() {
    this.getAgreement();
  },
  methods: {
    goBack() {
      this.$router.push({ name: "Login" });
    },
    getAgreement() {
      getUserAgreement()
        .then(res => {
          if (res.data) {
            try {
              const data =
                typeof res.data === "string" ? JSON.parse(res.data) : res.data;
              this.agreementContent = data.agreement || "";
            } catch (e) {
              this.agreementContent = res.data.agreement || "";
            }
          }
        })
        .catch(() => {
          this.agreementContent = "<p>加载失败，请稍后重试。</p>";
        });
    }
  }
};
</script>
<style scoped>
.agreement {
  min-height: 100vh;
  background: #fff;
}
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 44px;
  padding: 0 15px;
  background: #fff;
  border-bottom: 1px solid #eee;
}
.header .back {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
}
.header .back .iconfont {
  font-size: 20px;
  color: #333;
}
.header .title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}
.content {
  padding: 20px 15px;
}
.content h2 {
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 15px;
  color: #333;
}
.content h3 {
  font-size: 16px;
  font-weight: bold;
  margin: 20px 0 10px;
  color: #333;
}
.content h4 {
  font-size: 15px;
  font-weight: bold;
  margin: 15px 0 8px;
  color: #333;
}
.content p {
  font-size: 14px;
  line-height: 22px;
  color: #666;
  text-indent: 2em;
}
</style>
